import {
  AddToCart,
  IAddedCartItem,
} from "@faire/retailer-visitor-shared/events";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { History } from "history";
import sumBy from "lodash/sumBy";
import qs from "query-string";

const trackAddToCartEvent = (path: string, value: number) => {
  trackEvent(`/${path}/${value}`);
};

export const subscribeAddToCartEvents = (history: History) => {
  AddToCart.subscribe((event) => {
    const value = sumBy(event.added, (item: IAddedCartItem) => {
      return item.addedPrice;
    });
    const query = qs.parse(history.location.search);

    trackAddToCartEvent("client_add_to_cart_or_increase_quantity", value);

    if (/^\/product\/p_\w+(\/.*)?$/.test(history.location?.pathname ?? "")) {
      trackAddToCartEvent("client_product_page_add_to_cart", value);

      if (query.refS) {
        trackAddToCartEvent(
          "client_product_page_from_search_add_to_cart",
          value
        );
      } else if (query.refB) {
        trackAddToCartEvent(
          "client_product_page_from_brand_add_to_cart",
          value
        );
      }
    }

    if (
      /^\/retailer\/r_\w+\/brand\/b_\w+(\/.*)?$/.test(
        history.location?.pathname ?? ""
      )
    ) {
      trackAddToCartEvent(
        "client_add_to_cart_or_increase_on_brand_page",
        value
      );

      if (query.refS) {
        trackAddToCartEvent(
          "client_brand_page_from_search_quick_add_product",
          value
        );
      }
    }

    if (query.refS) {
      trackAddToCartEvent("client_add_to_cart_from_search_aggregated", value);
    }
  });
};
